export default __webpack_public_path__ + "890237414aec3dcdd48e38a9f45319a2.png";